import React from 'react';
import { useNavigate } from 'react-router-dom';

const Header = ({ pageTitle }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  // Ensure base path always ends with a slash
  const basePath = (process.env.REACT_APP_BASE_PATH || '').replace(/\/?$/, '/');

  return (
    <div style={{
      backgroundColor: '#1976d2', // Blue color matching the image
      color: 'white',
      display: 'flex',
      alignItems: 'center',
      gap: '16px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      marginBottom: '0'
    }}>
      {/* Logo */}
      <img 
        src={`${basePath}logo-header.png`} 
        alt="Write The World Logo" 
        onClick={handleLogoClick}
        style={{
          height: '60px',
          width: 'auto',
          objectFit: 'contain',
          margin: '5px',
          cursor: 'pointer'
        }}
      />
      
      {/* Page Title */}
      <h1 style={{
        margin: 0,
        fontSize: '24px',
        fontWeight: '500',
        color: 'white',
        flex: 1,
        textAlign: 'center'
      }}>
        {pageTitle}
      </h1>
    </div>
  );
};

export default Header;
